export function addEventToDataLayer({
  stckEventCategory = '',
  stckEventLabel = '',
  stckEventAction = 'click',
  event = 'stck',
}) {
  if (window?.dataLayer) {
    window.dataLayer.push({
      stckEventCategory,
      stckEventLabel,
      stckEventAction,
      event,
    });
  }
}
